<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__linkButton">mdi-link</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'linkButton',
  methods: {
    onClick () {
      this.$emit('click', 'createLink')
    }
  }
}
</script>

<style scoped>
#RTE__command__linkButton {
  font-size: 20px;
}
</style>
